import fetchPermissions from './getPermissions';
import watchDeletePermission from './deletePermission';

const watchPermissions = [fetchPermissions, watchDeletePermission];

export default watchPermissions;
